import React, { Component } from "react";
import DataTable from "react-data-table-component";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import ActividadesEducacionService from "../../../services/pagos/ActividadesEducacionService";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import Popup from "react-popup";

export default class EducacionPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.confirmar = this.confirmar.bind(this);
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getInitialState = () => ({
    datosActividad: [],
  });

  resetState = () => {
    this.setState(this.getInitialState());
  };
  componentDidMount() {
    this.getDatosActividad();
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector:row => row.valor,
      },
    ];
  }

  getDatosActividad() {
    var acti = this.props.actividad;
    var cabecera = this.props.cuentaDebito.cabecera;
    var cantidadEntradas = this.props.cantidadEntradas;
    var costoTotal;
    if(cabecera !== undefined){
      costoTotal = this.props.cantidadEntradas * cabecera.costo
    }

    var respuesta = [];
    if (cabecera !== undefined) {
      respuesta = [
        { concepto: "Nro. de actividad:", valor: acti[0].actividad },
        { concepto: "Nombre actividad:", valor: acti[0].descripcion },
        { concepto: "Fecha:", valor: cabecera.fecha },
        { concepto: "Hora:", valor: cabecera.hora },
        {
          concepto: "Ciudad:",
          valor: cabecera.ciudad.trim().length === 0 ? "-" : cabecera.ciudad,
        },
        {
          concepto: "Local:",
          valor: cabecera.lugar.trim().length === 0 ? "-" : cabecera.lugar,
        },
        {
          concepto: "Costo Unitario:",
          valor: formatoSeparadorMilesValue(cabecera.costo),
        },
        {
          concepto: "Cantidad:",
          valor: cantidadEntradas,
        },
        {
          concepto: "Costo Total:",
          valor: formatoSeparadorMilesValue(costoTotal),
        },
        { concepto: "Moneda:", valor: cabecera.moneda },
      ];
    }
    return respuesta;
  }
  confirmar() {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");
    var costoTotal = this.props.cantidadEntradas * this.props.cuentaDebito.cabecera.costo
    trackPromise(
      ActividadesEducacionService.suscripcionActividadesConfirma(
        this.props.actividad[0].actividad,
        this.props.cuentaDebito.value,
        costoTotal,
        this.props.cantidadEntradas
      ).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
     

        if (jData.codigoRetorno === "0") {
          this.props.returnDataPaso3(jData.numeroOperacion);
          this.nextStep.click();
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          Popup.queue(this.notifiPopup("Info", jData.mensajeRetorno));
        }
      })
    );
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Actividades
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <div className="form-group">
              <label className="input-label">Cuenta Origen (a debitar):</label>
              <br />
              <label className="input-label-bold">
                {this.props.cuentaDebito.label}
              </label>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <label className="input-label-bold">
              Inscripción de la Actividad
            </label>
            <div className="table-responsive">
              <DataTable
                noHeader={true}
                columns={this.getColumn()}
                data={this.getDatosActividad()}
                dense={true}
                noDataComponent="No hay datos que mostrar"
                responsive={true}
                noTableHead={true}
              />
            </div>
          </div>
        </div>

        <br />
        {this.props.cuentaDebito.cabecera && (
          <div className="row justify-content-md-center">
            <div className="col-md-8">
              <h6>
                Importe a Pagar:{" "}
                {formatoSeparadorMilesValue(
                  this.props.cuentaDebito.cabecera.importe
                )}{" "}
                {this.props.cuentaDebito.cabecera.moneda}.
              </h6>
            </div>
          </div>
        )}

        <hr />
        <div className="row">
        <div className="col-lg-8 col-md-6">
        <label
                className="input-label-bold"
                style={{ marginTop: 10 }}
              >
                ¿Está seguro que desea CONFIRMAR la operación?
                <br />
              </label>
        </div>
        <div className="col-lg-2 col-md-3 btn-consulta">
        <button
                className="btn btn-cu-quintary"
                onClick={this.props.previousStep}
              >
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
        </div>
        <div className="col-lg-2 col-md-3">
        <button className="btn btn-cu-primary" onClick={this.confirmar} ref={btn => { this.btn = btn; }}>
                {" "}
                Confirmar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>  
        </div>  
        </div>          
      </div>
    );
  }
}
